import { RawColumn, Section, SectionType } from '../models';

/**
 * Discriminator function for sections of `widget` type to find, filter
 * some parts of the application are in chared of displaying widget sections
 * like Tags
 * @param section
 */
export const isWidgetSection = <T extends RawColumn>(section: Pick<Section<T>, 'type'>): boolean =>
  section.type === SectionType.Widget;
